import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faSpinner, faTrainSubway, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import KtmbTimetableCard from './KtmbTimetableCard';

const KtmbTimetableResult = ({
  timetableData,
  errorMsg,
  searchLoading,
  onBack,
  onPrevDay,
  onNextDay,
  tabDate,
  setTabDate,
  setDate,
  fetchTimetableForDate
}) => {
  return (
    <div className="ktmb-timetable-bg compact">
      <div className="ktmb-timetable-card compact ktmb-card">
        <button className="ktmb-back-btn compact" onClick={onBack} title="Back to Search">
          <FontAwesomeIcon icon={faArrowLeft} size="lg" />
        </button>
        <div className="ktmb-header-nav-row">
          <button
            className="ktmb-date-nav-btn"
            onClick={() => {
              const prev = new Date(tabDate);
              prev.setDate(tabDate.getDate() - 1);
              setTabDate(prev);
              setDate(prev.toISOString().split('T')[0]);
              if (onPrevDay) onPrevDay(prev);
              fetchTimetableForDate(prev);
            }}
            aria-label="Previous day"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <div className="ktmb-header-center">
            <div className="header-main">
              <div className="ktmb-route">
                <div className="route-stations">
                  <span className="station from">{timetableData.fromStation || 'Origin'}</span>
                  <div className="route-arrow">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7"/>
                    </svg>
                  </div>
                  <span className="station to">{timetableData.toStation || 'Destination'}</span>
                </div>
              </div>
            </div>
            <div className="header-date-row">
              <div className="departure-date">
                {(() => {
                  const today = new Date();
                  if (tabDate.toDateString() === today.toDateString()) return 'Today';
                  return tabDate.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
                })()}
              </div>
            </div>
          </div>
          <button
            className="ktmb-date-nav-btn"
            onClick={() => {
              const next = new Date(tabDate);
              next.setDate(tabDate.getDate() + 1);
              setTabDate(next);
              setDate(next.toISOString().split('T')[0]);
              if (onNextDay) onNextDay(next);
              fetchTimetableForDate(next);
            }}
            aria-label="Next day"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
        {errorMsg && (
          <div className="ktmb-error-alert">{errorMsg}</div>
        )}
        {searchLoading && (
          <div className="ktmb-timetable-loading-overlay">
            <FontAwesomeIcon icon={faSpinner} spin size="2x" />
          </div>
        )}
        {timetableData.timetableList && timetableData.timetableList.length > 0 ? (
            <div 
              style={{
                maxHeight: '80vh',
                width: '100%',
                overflow: 'scroll'
              }}
            >
            <KtmbTimetableCard 
              from={timetableData.fromStation}
              to={timetableData.toStation}
              timetable={timetableData.timetableList}
              departureTime={timetableData.departDate}
            />
          </div>
        ) : (
          <div className="ktmb-no-data">
            <div className="ktmb-no-data-header">
              <div className="ktmb-route-display">
                <span className="ktmb-station-from">{timetableData.fromStation}</span>
                <span className="ktmb-route-arrow">→</span>
                <span className="ktmb-station-to">{timetableData.toStation}</span>
              </div>
              <div className="ktmb-date-display">
                {new Date(timetableData.departDate).toLocaleDateString('en-US', { 
                  weekday: 'long',
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </div>
            </div>
            <div className="ktmb-no-data-message">
              <div className="ktmb-no-data-icon">🚂</div>
              <div className="ktmb-no-data-text">No trains available for this date</div>
              <div className="ktmb-no-data-subtext">Try selecting a different date or route</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default KtmbTimetableResult; 